export { default as AppInfo } from "./AppInfo";
